import script from "./modal_addnewfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal_addnewfile.vue?vue&type=script&setup=true&lang=ts"

import "./modal_addnewfile.vue?vue&type=style&index=0&id=086f41a7&lang=css"

const __exports__ = script;

export default __exports__